export default __webpack_public_path__ + "static/media/lamps1.9d517d98.png";